import React, { useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import classes from "../../scss/Posts.module.scss";
import loaderClasses from "../../components/commons/Loader.module.scss";
import { FetchContext } from "../../context/FetchContext";
import { getFilters } from "../../helpers/getFilters";
import TagsList from "../../components/commons/Tags/List";
import Preview from "./Preview";
import wrapperClasses from "../../components/commons/Wrapper.module.scss";

const Posts = () => {
  const {
    store: {
      posts,
      posts: {
        queries: { posts: postsQuery, tags: tagsQuery },
        filters: { activeTags },
        posts: { hasMore, loading: postsLoading },
        tags: { loading: tagsLoading },
      },
    },
    getItem,
    toggleActiveTag,
    checkIsTagActive,
    resetTags,
    setFilterQuery,
    setPageQuery,
  } = useContext(FetchContext);

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const { ref, inView } = useInView();

  useEffect(() => {
    postsLoading || tagsLoading ? setLoading(true) : setLoading(false);
  }, [tagsLoading, postsLoading]);

  const incrementPage = () =>
    setPage((prev) => {
      return prev + 1;
    });

  const getTags = getFilters(1);

  useEffect(() => {
    hasMore && inView && incrementPage();
  }, [inView, hasMore]);

  useEffect(() => {
    getItem({
      cb: getTags,
      propName: "tags",
      entity: "posts",
      query: tagsQuery,
    });
  }, [JSON.stringify(tagsQuery)]);

  useEffect(() => {
    getItem({
      propName: "posts",
      entity: "posts",
      query: postsQuery,
    });
  }, [JSON.stringify(postsQuery)]);

  useEffect(() => {
    setFilterQuery(activeTags, "posts", "posts");
    setFilterQuery(activeTags, "posts", "posts");
  }, [activeTags, setFilterQuery]);

  useEffect(() => {
    setPageQuery("posts", "posts", page);
    return () => {
      setPageQuery("posts", "posts", 1);
    };
  }, [page, setPageQuery]);

  return (
    <section className={wrapperClasses.section}>
      {loading ? <div className={loaderClasses.loader} /> : null}

      {posts.posts.data ? (
        <div className={classes.posts__container}>
          <div className={classes.header}>
            <TagsList
              toggleActiveTag={toggleActiveTag}
              checkIsTagActive={checkIsTagActive}
              getItem={getItem}
              tags={posts?.tags}
              setPage={setPage}
              resetTags={resetTags}
              activeTags={activeTags}
              entity="posts"
            />
          </div>
          {posts.posts.data.map((post, index, self) => (
            <Preview
              key={post.id}
              post={post}
              viewRef={ref}
              index={index + 1 < 10 ? `0${index + 1}` : index + 1}
              inView={index === self.length - 1}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
};

export default Posts;
